<template>
  <div>
    <div class="form-row">
      <h3>Manage Customer Details List</h3>
    </div>
    <!-- <ul>
      <li v-for="user in users" :key="user.userId">
        <router-link :to="{ name: 'Profile', params: { id: user.userId } }">
          {{ user.userName }} Profile
        </router-link>
      </li>
    </ul> -->
    <div style="text-align: left; padding-bottom: 1px">
      <ejs-button type="button" cssClass="e-info" v-on:click.native="onAddNewUserClick">
        <font-awesome-icon :icon="['fas', 'plus']" style="display: inline" /> Add New Customer
      </ejs-button>
    </div>
    <!-- <div class="form-row"> -->
    <ejs-grid
      :dataSource="users"
      ref="refUserList"
      :created="created"
      enablePersistence="true"
      :selection-settings="selectionOptions"
      :commandClick="commandClick"
      :allowSorting="true"
      :allowPaging="true"
      :pageSettings="pageSettings"
      :toolbar="toolbarOptions"
    >
      <e-columns>
        <e-column
          field="userId"
          headerText="User ID"
          textAlign="Left"
          :isPrimaryKey="true"
          width="0"
        ></e-column>
        <e-column headerText="Edit" width="8%" :commands="commands" textAlign="Lift"></e-column>
        <e-column
          field="userProfile.userFullName"
          width="12%"
          headerText="Name"
          textAlign="Left"
        ></e-column>
        <e-column field="userName" width="25%" headerText="Email" textAlign="Left"></e-column>
        <e-column field="userProfile.address" headerText="Address" textAlign="Left"></e-column>
        <e-column field="userProfile.cityName" headerText="City" textAlign="Left"></e-column>
        <e-column
          field="userProfile.provinceName"
          headerText="Province"
          textAlign="Left"
        ></e-column>
        <e-column
          field="userProfile.postalCode"
          headerText="Postal Code"
          textAlign="Left"
        ></e-column>
      </e-columns>
    </ejs-grid>
    <!-- </div> -->
  </div>
</template>

<script>
import Vue from "vue";
import {
  GridPlugin,
  Page,
  Toolbar,
  Edit,
  CommandColumn,
  Sort,
  Search,
} from "@syncfusion/ej2-vue-grids";
import { FETCH_ACTIVE_INACTIVE_USERS } from "../store";

Vue.use(GridPlugin);

export default {
  name: "Users",
  created() {
    this.userList();
  },
  computed: {
    // users() {
    //   return this.$store.getters.userList;
    // },
  },
  mounted() {
    this.$refs.refUserList.ej2Instances.searchSettings.key = "";
  },
  data() {
    return {
      selectionOptions: {
        type: "Single",
        enableSimpleMultiRowSelection: false,
        enableToggle: true,
        persistSelection: true,
      },
      users: [],
      toolbarOptions: ["Search"],
      pageSettings: { pageSize: 10 },
      commands: [
        {
          type: "Edit",
          buttonOption: { cssClass: "e-flat", iconCss: "e-edit e-icons" },
        },
      ],
    };
  },
  methods: {
    created() {
      // Added clear button and its functionalities to Searchbar

      if (this.$refs.refUserList) {
        const refUserListSearchEle = document.getElementById(
          `${this.$refs.refUserList.$el.id}_searchbar`,
        );
        if (refUserListSearchEle) {
          refUserListSearchEle.addEventListener("keyup", (e) => {
            this.clearSearchEventListener(e, this.$refs.refUserList.$el.id);
          });
        }
      }
    },
    clearSearchEventListener(e, gridId) {
      const searchBtnEle = document.getElementById(`${gridId}_searchbutton`);
      const clearBtnEle = searchBtnEle.cloneNode(true);
      clearBtnEle.id = `${gridId}_clearbutton`;
      clearBtnEle.classList.remove("e-search-icon");
      clearBtnEle.classList.add("e-clear-icon");

      clearBtnEle.addEventListener("click", () => {
        e.target.value = "";
        document.getElementById(`${gridId}_clearbutton`).remove();
      });

      if (e.target.value && searchBtnEle.parentNode.childElementCount == 2) {
        searchBtnEle.parentNode.insertBefore(clearBtnEle, searchBtnEle.parentNode.children[1]);
      } else if (!e.target.value || e.target.value == "") {
        document.getElementById(`${gridId}_clearbutton`).remove();
      }
    },
    commandClick(args) {
      if (args.commandColumn.type === "Edit") {
        this.$router.push(`/manage-customer/${args.rowData.userId}`);
      }
    },
    onAddNewUserClick() {
      const userId = null;
      this.$router.push(`/manage-customer/${userId}`);
    },
    async userList() {
      // this.$parent.$parent.notificationToasts.length = 0;
      try {
        await this.$store.dispatch(FETCH_ACTIVE_INACTIVE_USERS).then(() => {
          this.users = this.$store.getters.activeUsers;
        });
      } catch (err) {
        console.error(err);
      }
    },
  },
  provide: {
    grid: [Page, Edit, Toolbar, CommandColumn, Sort, Search],
  },
};
</script>

<style>
@import "../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";
/* ul {
  text-align: left;
} */
.e-card-content {
  margin: 0% !important;
}
</style>
